import { toLower } from "lodash";

export const toCompactNumber = (
  value: number,
  maxDecimalPlaces = 3,
  invalidNumberFallback = "NA"
): string => {
  const formattedValue = Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: maxDecimalPlaces,
  }).format(value);

  if (formattedValue === "NaN") {
    return invalidNumberFallback;
  }

  return toLower(formattedValue);
};
